import { SET_USER, SET_EMAIL, SET_PAYMENT_NEXT_ACTION, SET_PAYMENTS, SET_CLOUD_USAGE, SET_SUBSCRIPTION } from "../actions/user"

function getCloudMaxUsage(user) {
    const customerType = user?.metadata?.customerType
    if (customerType === 'selfEmployed') return { value: 1024 * 1024 * 20000, label: '20Go' }
    if (customerType === 'company') return { value: 1024 * 1024 * 50000, label: '50Go' }
    return { size: 1024 * 1024 * 5000, label: '5Go' }
}

const user = (state, action) => {

    if (!state) {
        state = { user: {}, payments: [], cloud: { usage: 0, maxUsage: getCloudMaxUsage() }, subscription: {} };

        // user
        const user = window.localStorage.getItem('user');
        if (user) state.user = JSON.parse(user);

        // email
        const email = window.localStorage.getItem('email');
        if (email) state.email = email;
    }

    switch (action.type) {
        case SET_USER:
            const user = action.user;
            user.connected = !!(user.id && user.status !== 'pending');
            window.localStorage.setItem('user', JSON.stringify(user));

            state.cloud.maxUsage = getCloudMaxUsage(user)

            return Object.assign({}, state, { user, cloud: state.cloud })
        case SET_EMAIL:
            const email = action.email;
            if (email) {
                window.localStorage.setItem('email', email);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'user_data',
                    email: email
                });
            }
            return Object.assign({}, state, { email });
        case SET_PAYMENT_NEXT_ACTION:
            return Object.assign({}, state, { paymentNextAction: action.nextAction })
        case SET_PAYMENTS:
            return Object.assign({}, state, { payments: action.value })
        case SET_CLOUD_USAGE:
            return Object.assign({}, state, { cloud: { usage: parseInt(action.cloudUsage), maxUsage: getCloudMaxUsage() } })
        case SET_SUBSCRIPTION:
            return Object.assign({}, state, { subscription: action.subscription })
        default:
            return state;
    }
}

export default user;
